import holidaysService from "@/services/holidaysService";

const state = () => ({
  all: []
});

const actions = {
  async createAll({ dispatch }, formData) {
    try {
      await holidaysService.createAll(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Feiertage wurden erfolgreich gespeichert. Dublikate wurden dabei herausgefiltert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ferientage konnten nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ dispatch }) {
    try {
      const res = await holidaysService.findAll();
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Ferientage konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findBetweenRange({ dispatch }, formData) {
    try {
      const res = await holidaysService.findBetweenRange(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Ferientage-Range konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await holidaysService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async downloadByYear({ dispatch }, formData) {
    try {
      const res = await holidaysService.downloadByYear(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Ferientage API kann momentan nicht erreicht werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAllFeatureTags(state, object) {
    state.all = object;
  },
  setSingleFeatureTag(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
